const elemEkomi = document.querySelectorAll('.wdgt-Ekomi');
window.fireOnVisible(elemEkomi, async () => {
    await import('./assets/css/wt_ekomi.scss');
});
